import { render, staticRenderFns } from "./nice-spoiler.vue?vue&type=template&id=4f6315c0&scoped=true"
import script from "./nice-spoiler.vue?vue&type=script&lang=js"
export * from "./nice-spoiler.vue?vue&type=script&lang=js"
import style0 from "./nice-spoiler.vue?vue&type=style&index=0&id=4f6315c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6315c0",
  null
  
)

export default component.exports